import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "8",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "4",
  cy: "4",
  r: "4",
  class: "fill-fg-secondary"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "16",
  cy: "4",
  r: "4",
  class: "fill-fg-tertiary"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "28",
  cy: "4",
  r: "4",
  class: "fill-fg-placeholder"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }